export default "__VITE_ASSET__BGnFBguO__"